<template>
  <div>
    <v-card-text class="pa-0" style="height: 600px; overflow-y: auto;">
      <v-layout class="pa-2" row wrap style="height: auto;">

        <!-- Vasen -->
        <v-flex xs6 style="padding-bottom: 5px;" pr-1>
          <v-layout row>
            <v-flex xs10>
              <v-text-field v-model="identifier" label="Identifier" autofocus @change="add_identifier"></v-text-field>
            </v-flex>
<!--            <v-flex xs2>
              <v-btn class="success" @click="add_identifier">Add </v-btn>
            </v-flex>-->
          </v-layout>
          <template v-for="(device,idx) in devices">
            <v-layout row>
                <v-flex xs3>{{device.identifier}}</v-flex>
                <v-flex xs3><v-chip small>{{get_type_title(device.type)}}</v-chip></v-flex>
                <v-flex xs4><v-chip small>{{get_content_model(device.form_data.model, "name")}}</v-chip></v-flex>

                <v-flex xs2>
                  <v-btn flat small @click="del_identifier(idx)"><v-icon>delete</v-icon></v-btn>
                </v-flex>
            </v-layout>

            </template>
        </v-flex>

        <!-- Oikea -->
        <v-flex xs6>
          <div v-if="device_type">
            <v-text-field label="Comment" v-model="comment"></v-text-field>
            <v-layout row>
              <v-flex xs1><v-checkbox v-model="use_status_id"></v-checkbox></v-flex>
              <v-flex xs11>
                <select-content-list :clearable="false" label="Status" :list_id="device_type.value.status_list_id" v-model="status_id" item-value="id" item-text="name"></select-content-list>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs1><v-checkbox v-model="use_usage_id"></v-checkbox></v-flex>
              <v-flex xs11>
                <select-content-list :clearable="false" label="Usage" :list_id="device_type.value.usage_list_id" v-model="usage_id" item-value="id" item-text="name"></select-content-list>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs1><v-checkbox v-model="use_location_id"></v-checkbox></v-flex>
              <v-flex xs11>
                <select-content-list :clearable="false" label="Location" :list_id="device_type.value.location_list_id" v-model="location_id" item-value="id" item-text="name"></select-content-list>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs1><v-checkbox v-model="use_series_id"></v-checkbox></v-flex>
              <v-flex xs11>
                <select-content-list :clearable="false" label="Series" :list_id="device_type.value.series_list_id" v-model="series_id" item-value="id" item-text="name"></select-content-list>
              </v-flex>
            </v-layout>
          </div>
          <v-layout row>
            <v-flex xs6>
              <v-checkbox label="Update all subdevices" v-model="update_all_subdevices"></v-checkbox>
            </v-flex>
            <v-flex xs6>
              <v-checkbox label="Remove all subdevices" v-model="remove_subdevices"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>

    <!-- Actions -->
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="save(false)">Save</v-btn>
      <v-btn color="success" @click="save(true)">Save and close</v-btn>
    </v-card-actions>

  </div>
</template>


<script>
import * as FormItems from '@/components/form_items'
import SettingsModel from '@/models/settings.js';
import SelectContentList from '@/components/SelectContentList'

export default {
  data () {
    var ch = this.$cloudserver.channel("devices:create");
    return {
      ws_channel: ch,
      identifier: "",
      devices: [],
      use_status_id: false,
      use_usage_id: false,
      use_location_id: false,
      use_series_id: false,
      status_id: undefined,
      location_id: undefined,
      series_id: undefined,
      usage_id: undefined,
      comment: "",
      remove_subdevices: false,
      update_all_subdevices: false
    }
  },
  components: {
    SelectContentList,
    ...FormItems
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
   device_type () {
    return SettingsModel.list("device_type")[0];
   }
  },

  methods: {
    get_type_title(type) {
      var setting = SettingsModel.get_by_name(type);
      if (typeof(setting) != "undefined") {
        return setting.title || type;
      }
      return type;
    },
    get_content_model(field, name) {
      if (typeof(field) != "undefined" && field != null) {
        return field[name];
      }
      return "";
    },
    add_identifier () {
      var self = this;
      var new_device = _.find(this.$store.state.devices, function(device) {
        return device.identifier == self.identifier;
      });
      if (typeof(new_device) != "undefined") {
        this.devices.push(new_device);
        this.identifier = "";
      }
    },
    del_identifier (idx) {
      var new_list = this.devices;
      new_list.splice(idx,1);
      this.devices = new_list;
    },
    get_device(id) {
      return this.$store.state.devices[id];
    },
    get_subdevices(parent_device) {
      var self = this;
      var device_list = [];
      _.each(parent_device.sub_device_list, function(id) {
        var device = self.get_device(id);
        device_list.push([device, self.get_subdevices(device)]);
      });
      return device_list;
    },

    save (close) {
      var self = this;
      if (typeof(this.ws_channel) != "undefined") {
        var device_log = {meta: {comment: self.comment}}

        var all_devices = self.devices;

        // tehdään muutokset myös kaikille alilaitteille
        if (self.update_all_subdevices == true) {
          var ndev = _.map(all_devices, function(device) {
            return _.flattenDeep(self.get_subdevices(device));
          });

          ndev = _.flatten(ndev);

          all_devices = all_devices.concat(ndev);
        }

        var devices = _.map(all_devices, function(device) {
          if (self.use_status_id == true) {device.status_id = self.status_id};
          if (self.use_location_id == true) {device.location_id = self.location_id};
          if (self.use_usage_id == true) {device.usage_id = self.usage_id};
          if (self.use_series_id == true) {device.series_id = self.series_id};
          return device;
        });

        _.each(devices, function(device) {
          var save_map = {device: device, device_log: device_log};

          if (self.remove_subdevices == true) {
            save_map["subdevices"] = [];
          }

          self.ws_channel.save(save_map)
          .then((msg) => {
            self.$message.success("Device was updated!");
            if (close) {
              self.$root.close_bottom_sheet();
            }
          })
          .catch((msg) => {
            console.log(msg);
            self.$message.warning("Unable to update device!");
          });          
        });

      }
    },
  }

}
</script>